import { IconProps } from './IconProps';
export function MusicalNoteIcon(props: IconProps) {
    return (
        <svg
            {...props}
            width="22"
            height="22"
            viewBox="0 0 22 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M7.66663 17.6667V3.22222L21 1V15.4444"
                stroke="#121A44"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M4.33333 20.9997C6.17428 20.9997 7.66667 19.5073 7.66667 17.6663C7.66667 15.8254 6.17428 14.333 4.33333 14.333C2.49238 14.333 1 15.8254 1 17.6663C1 19.5073 2.49238 20.9997 4.33333 20.9997Z"
                stroke="#121A44"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M17.6667 18.777C19.5077 18.777 21 17.2846 21 15.4437C21 13.6027 19.5077 12.1104 17.6667 12.1104C15.8258 12.1104 14.3334 13.6027 14.3334 15.4437C14.3334 17.2846 15.8258 18.777 17.6667 18.777Z"
                stroke="#121A44"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
